import React from "react"

import LineLayer from "../../GraphSVGLayers/LineLayer"
import PointLayer from "../../GraphSVGLayers/PointLayer"
import { arrayWithContents } from "../../../../utils"
import { getXValue } from "../../../resources/utils"
import { set_bounds } from "../utils"

export default function ObservationSVGLayer({
  style,
  data,
  x,
  y,
  colour,
  pointSize,
  pointModifier,
  strokeWidth,
  strokeModifier,
  timeExtractor,
  trendDayOffset = 0,
}) {
  const sharedProps = {
    data: data,
    colour: colour,
    getXValue: (obs) => x(getXValue(obs, timeExtractor, trendDayOffset)),
    getYValue: (obs) => set_bounds(y(obs.value)),
  }
  const pointProps = {
    ...sharedProps,
    pointSize: pointSize || 2,
    pointModifier: pointModifier,
  }
  const lineProps = {
    ...sharedProps,
    strokeWidth: strokeWidth ? strokeWidth : style === "linespoints" ? 1 : 3,
    strokeModifier: strokeModifier,
  }

  if (style === "line" && arrayWithContents(data) && data.length > 1) {
    return <LineLayer {...lineProps} strokeWidth={strokeWidth} />
  } else if (style === "linespoints") {
    return (
      <>
        <LineLayer {...lineProps} />
        <PointLayer {...pointProps} />
      </>
    )
  } else {
    return <PointLayer {...pointProps} />
  }
}
